import { Navigate, Outlet } from "react-router-dom";
import { Spin } from "antd";
import { AppRole } from "@/types";
import { useMe } from "@/hooks/useMe";

interface RoleRouteProps {
  allow: AppRole[];
  redirectTo?: string;
}

/**
 * Route guard that only renders its children when the current user's
 * application role (from GET /api/me) is in `allow`. The real enforcement
 * lives in the backend (endpoints return 403); this just keeps the UI honest
 * and prevents navigating to a page the user can't use.
 */
export default function RoleRoute({ allow, redirectTo = "/share" }: RoleRouteProps) {
  const { role, isLoading } = useMe();

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
        <Spin />
      </div>
    );
  }

  if (!allow.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
